/* eslint-disable */
/*
* shared.js
*
* Description: Holds 'Stores' Logic for Module:'Shared'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Flights"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import router from '@/router'; // after login

import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> Drawer -----------------------------------------
    barColor: 'rgba(45, 62, 82, 1), rgba(45, 62, 82, 1)',
    barImage: '', /* is OFF right now, LEA */
    shared_Drawer: true,

    // >>> Login ------------------------------------------
    sharedLoginResults: {}, // Results::Login
    idGroup: null,
    idResource: null,
    idUser: null,
    realName: null,
    userName: null,
    shared_usersGrantsList: [],

    // >>> Path -------------------------------------------
    shared_Path: null,

    // >>> Airports ---------------------------------------
    sharedAirportResults: {}, // Results::Airports
    // >>> Aircrafts --------------------------------------
    people_aircraftConfigs: [],
    people_aircraftConfigs_complaintManagement: [],
    shared_airportTaxes: [],
    // >>> Countries --------------------------------------
    people_Countries: [],
    // >>> Bases ------------------------------------------
    people_Bases: [],

    // >>> All Employees ----------------------------------
    shared_AllEmployeesResults: [], // Results::'All Employees'
    shared_SelectedMultiResources: [], // Multi Reources Select

    // >>> Warning ----------------------------------------
    warning: null,
    // >>> smallScreen -------------------------------------
    isDesktop: true,
    isSmallDesktop: false,
    isMobile: false,
    isPortrait: true,
};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * isAuthenticated()
    *
    * Desc: Dear ... are we authenticated?
    * Note:
    *
    */
    isAuthenticated: state => {

        return state.idUser !== null;

    }, // eof isAuthenticated()


    /***************************************************************************
    * getIdUser()
    *
    * Desc:
    * Note:
    *
    */
    getIdUser: state => {

        return state.idUser;

    }, // eof getIdUser()

    /***************************************************************************
    * getIdGroup()
    *
    * Desc:
    * Note: Group 1 === Admin
    *
    */
    getIdGroup: state => {

        return state.idGroup;

    }, // eof getIdGroup()

    /***************************************************************************
    * getIdResource()
    *
    * Desc:
    * Note:
    *
    */
    getIdResource: state => {

        return state.idResource;

    }, // eof getIdResource()


    /***************************************************************************
    * get_Shared_UsersGrantsList()
    *
    * Desc: Return Grabnts List (Note: from /login Response).
    * Note:
    *
    */
    get_Shared_UsersGrantsList: state => {

        return state.shared_usersGrantsList;

    }, // eof get_Shared_UsersGrantsList()



    /***************************************************************************
    * get_Shared_UsersGrantsList()
    *
    * Desc: Return Grabnts List (Note: from /login Response).
    * Note:
    *
    */
    get_Shared_isUserAllowedToUse: state => p => {

        return Vue.prototype.$isUserAllowedToUse(p);

    }, // eof get_Shared_UsersGrantsList()




    /***************************************************************************
    * Getters: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * get_shared_Path()
    *
    * Desc:
    * Note:
    *
    */
     get_shared_Path: state => {

        return state.shared_Path;

    }, // eof get_shared_Path()
     
     
     
    /***************************************************************************
    * Getters: 'Shared' - 'Drawer'
    ***************************************************************************/
    /***************************************************************************
    * get_shared_Drawer()
    *
    * Desc:
    * Note:
    *
    */
    get_shared_Drawer: state => {

        return state.shared_Drawer;

    }, // eof get_shared_Drawer()



    /***************************************************************************
    * Getters: 'Shared' - AircraftConfigs
    ***************************************************************************/
    /***************************************************************************
    * get_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    get_AircraftConfigs: state => {

        // sort by capacity and code
        state.people_aircraftConfigs = state.people_aircraftConfigs.sort((a, b) => {

            if (a.capacityY > b.capacityY) {
                return -1;
            }
            if (a.capacityY < b.capacityY) {
                return 1;
            }

            if (a.code < b.code) {
                return -1;
            }
            if (a.code > b.code) {
                return 1;
            }
        });

        // -1 = a wins
        // 1  = b wins

        // "sort" by company to "split" between SUNDAIR and FLYAIR
        // everything with "SUB" goes to the bottom
        state.people_aircraftConfigs = state.people_aircraftConfigs.sort((a, b) => {

            // FLYAIR and SUNDAIR
            if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === true) {
                    return 0;
                }
                if (a.code.startsWith('FlyAir') === false && b.code.startsWith('FlyAir') === true) {
                    return -1;
                }
                if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === false) {
                    return 1;
                }
            }
            if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === true) {
                    return 0;
                }
                if (a.code.startsWith('D-') === false && b.code.startsWith('D-') === true) {
                    return -1;
                }
                if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === false) {
                    return 1;
                }
            }

            // SUBs
            if (a.code.includes('SUB') === true && a.code > b.code) {
                return 1;
            }
            if (b.code.includes('SUB') === true && a.code < b.code) {
                return -1;
            }

        });
        return state.people_aircraftConfigs;

    }, // eof get_AircraftConfigs()

    /***************************************************************************
    * Getters: 'Shared' - AircraftConfigs
    ***************************************************************************/
    /***************************************************************************
    * get_AircraftConfigs_complaintManagement()
    *
    * Desc:
    * Note:
    *
    */
    get_AircraftConfigs_complaintManagement: state => {

        // sort by capacity and code
        state.people_aircraftConfigs_complaintManagement = state.people_aircraftConfigs_complaintManagement.sort((a, b) => {

            if (a.capacityY > b.capacityY) {
                return -1;
            }
            if (a.capacityY < b.capacityY) {
                return 1;
            }

            if (a.code < b.code) {
                return -1;
            }
            if (a.code > b.code) {
                return 1;
            }
        });

        // -1 = a wins
        // 1  = b wins

        // "sort" by company to "split" between SUNDAIR and FLYAIR
        // everything with "SUB" goes to the bottom
        state.people_aircraftConfigs_complaintManagement = state.people_aircraftConfigs_complaintManagement.sort((a, b) => {

            // FLYAIR and SUNDAIR
            if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === true) {
                    return 0;
                }
                if (a.code.startsWith('FlyAir') === false && b.code.startsWith('FlyAir') === true) {
                    return -1;
                }
                if (a.code.startsWith('FlyAir') === true && b.code.startsWith('FlyAir') === false) {
                    return 1;
                }
            }
            if (a.code.includes('SUB') === false && b.code.includes('SUB') === false) {
                if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === true) {
                    return 0;
                }
                if (a.code.startsWith('D-') === false && b.code.startsWith('D-') === true) {
                    return -1;
                }
                if (a.code.startsWith('D-') === true && b.code.startsWith('D-') === false) {
                    return 1;
                }
            }

            // SUBs
            if (a.code.includes('SUB') === true && a.code > b.code) {
                return 1;
            }
            if (b.code.includes('SUB') === true && a.code < b.code) {
                return -1;
            }

        });
        return state.people_aircraftConfigs_complaintManagement;

    }, // eof get_AircraftConfigs_complaintManagement()




    /***************************************************************************
    * Getters: 'Shared' - AirportTaxes
    ***************************************************************************/
    /***************************************************************************
    * get_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    get_AirportTaxes: state => {

        return state.shared_airportTaxes;

    }, // eof get_AirportTaxes()




    /***************************************************************************
    * Getters: 'Shared' - Countries
    ***************************************************************************/
    /***************************************************************************
    * get_Countries()
    *
    * Desc:
    * Note:
    *
    */
    get_Countries: state => {

        return state.people_Countries;

    }, // eof get_Countries()




    /***************************************************************************
    * Getters: 'Shared' - Bases
    ***************************************************************************/
    /***************************************************************************
    * get_Bases()
    *
    * Desc:
    * Note:
    *
    */
    get_Bases: state => {

        return state.people_Bases;

    }, // eof get_Bases()




    /***************************************************************************
    * Getters: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * get_AllEmployees()
    *
    * Desc:
    * Note: Still empty!
    *
    */
    get_AllEmployees: state => {

        return state.shared_AllEmployeesResults;

    }, // eof get_AllEmployees()


    /***************************************************************************
    * get_selectedMultiResources()
    *
    * Desc: Return selected Multi Resources.
    * Note: Still empty!
    *
    */
    get_selectedMultiResources: state => {

        return state.shared_SelectedMultiResources;

    }, // eof get_selectedMultiResources()

    /***************************************************************************
    * get_warning()
    *
    * Desc: Return warning Object.
    * Note:
    *
    */
    get_warning: state => {

        return state.warning;

    }, // eof get_warning()

    /***************************************************************************
    * get_isPortrait()
    *
    * Desc: Return smallScreen Boolean.
    * Note:
    *
    */
    get_isPortrait: state => {

        return state.isPortrait;

    }, // eof get_isPortrait()

    /***************************************************************************
    * get_isDesktop()
    *
    * Desc: Return smallScreen Boolean.
    * Note:
    *
    */
    get_isDesktop: state => {

        return state.isDesktop;

    }, // eof get_isDesktop()

    /***************************************************************************
    * get_isSmallDesktop()
    *
    * Desc: Return smallScreen Boolean.
    * Note:
    *
    */
    get_isSmallDesktop: state => {

        return state.isSmallDesktop;

    }, // eof get_isSmallDesktop()

    /***************************************************************************
    * get_isMobile()
    *
    * Desc: Return smallScreen Boolean.
    * Note:
    *
    */
    get_isMobile: state => {

        return state.isMobile;

    }, // eof get_isMobile()

    /***************************************************************************
    * get_shared_IsEditingInThePastAllowed()
    *
    * Desc: Reads from 'User Grants'. (from '/login' Response).
    * Note: Getter with Payload!
    * Note: Ticket #4
    *
    */
    get_shared_IsEditingInThePastAllowed: state => {

        let accessAllowed = false;


        if (state.shared_usersGrantsList.includes('sc2.flights.admin.past')) {  // TODO: create this grant
            accessAllowed = true;
        }


        return accessAllowed;

    }, // eo function get_shared_IsEditingInThePastAllowed()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Shared' - 'Drawer'
    ***************************************************************************/
    /***************************************************************************
    *
    * Desc:
    * Note:
    *
    */
    SET_BAR_IMAGE: (state, payload) => {

        state.barImage = payload;

    }, // eof SET_BAR_IMAGE()

    SET_DRAWER: (state, payload) => {
        
        state.shared_Drawer = payload;

    }, // eof SET_DRAWER()

    SET_SCRIM: (state, payload) => {

        state.barColor = payload;

    }, // eof SET_SCRIM()




    /***************************************************************************
    * Mutations: 'Shared' - 'Login'
    ***************************************************************************/
    /***************************************************************************
    * mut_userLogin()
    *
    * Desc: User Login.
    * Note: NEW! We now have 'grants' in Logins Response.
    * Note: Redirect to '/' Dashboard(!) (bec: First need to check 'grants').
    *
    */
    mut_userLogin: (state, payload) => {

        state.sharedLoginResults = payload;
        state.idGroup = payload.idGroup;
        state.idResource = payload.idResource;
        state.idUser = payload.idUser;
        state.realName = payload.realName;
        state.userName = payload.userName;
        state.shared_usersGrantsList = payload.grants;
        
        router.push('/');

    }, // eof mut_userLogin()




    /***************************************************************************
    * Mutations: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * mut_set_Path()
    *
    * Desc:
    * Note:
    *
    */
     mut_set_Path: (state, payload) => {

        state.shared_Path = payload;

    }, // eof mut_set_Path()




    /***************************************************************************
    * Mutations: 'Shared' - 'Countries'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Countries()
    *
    * Desc: Save countries to state.
    * Note: Countries are not sorted, sort them by name.
    *
    */
    mut_call_Countries: (state, payload) => {

        let sortedCountries = [...payload];


        sortedCountries.sort((a, b) => a.name < b.name ? -1 : 1);

        state.people_Countries = sortedCountries;

    }, // eof mut_call_Countries()




    /***************************************************************************
    * Mutations: 'Aircrafts'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AircraftConfigs()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AircraftConfigs: (state, payload) => {

        state.people_aircraftConfigs = payload.filter(p => p.active);
        state.people_aircraftConfigs_complaintManagement = payload.filter(p => p.active || (p.code === 'D-ASSB' || p.code === 'D-ASSM')); // Ticket#72

    }, // eof mut_call_AircraftConfigs()




    /***************************************************************************
    * Mutations: 'AirportTaxes'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_AirportTaxes()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_AirportTaxes: (state, payload) => {

        let sortedAirports = [...payload];


        sortedAirports.sort((a, b) => a.aptCode < b.aptCode ? -1 : 1);

        state.shared_airportTaxes = sortedAirports;
        // state.shared_airportTaxes = payload;

    }, // eof mut_call_AirportTaxes()



    /***************************************************************************
    * Mutations: 'Shared' - 'Bases'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_Bases()
    *
    * Desc: Save countries to state.
    * Note:
    *
    */
    mut_call_Bases: (state, payload) => {

        state.people_Bases = payload;

    }, // eof mut_call_Bases()




    /***************************************************************************
    * Mutations: 'Shared' - 'Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * mut_update_DutyPlanChanges()
    *
    * Desc: Update List 'All Employees' with new 'created' TimeStamp.
    * Note:
    *
    */
    mut_update_DutyPlanChanges: (state, payload) => {

        let sr = null;


        payload.forEach((item, i) => {
            sr = state.shared_AllEmployeesResults.find(resource => resource.id === item.idResource);
            sr.lastDutyPlanRelease = item.created;
        });

    }, // eof mut_update_DutyPlanChanges()




    /***************************************************************************
    * Mutations: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * mut_load_AllEmployees()
    *
    * Desc: After Load 'All Employees'.
    * Note:
    *
    */
    mut_load_AllEmployees: (state, payload) => {

        payload.sort((a, b) => (a.genLastname > b.genLastname) ? 1 : ((b.genLastname > a.genLastname) ? -1 : 0));
        state.shared_AllEmployeesResults = payload;

    }, // eof mut_load_AllEmployees()




    /***************************************************************************
    * Mutations: 'Shared' Selected Resources'
    ***************************************************************************/
    /***************************************************************************
    * mut_set_shared_SelectedMultiResources()
    *
    * Desc: Set
    * Note:
    *
    */
    mut_set_shared_SelectedMultiResources: (context, payload) => {

        state.shared_SelectedMultiResources = payload;

    }, // eof mut_set_shared_SelectedMultiResources()


    /***************************************************************************
    * Mutations: 'Shared' - Set Warning (Dialog Popover)
    ***************************************************************************/
    /***************************************************************************
    * mut_set_warning()
    *
    * Desc: Set warning
    * Note:
    *
    */
    mut_set_warning: (context, payload) => {

        state.warning = payload;

    }, // eof mut_set_warning()

    /***************************************************************************
    * Mutations: 'Shared' - Set smallScreen
    ***************************************************************************/
    /***************************************************************************
    * mut_set_isDesktop()
    *
    * Desc: Set smallScreen
    * Note:
    *
    */
    mut_set_isDesktop: (context, payload) => {
        
        let isDesktop = true,
            isSmallDesktop = false,
            isPortrait = true,
            isMobile = false;

        if (payload.innerWidth < 900) {
            isDesktop = false;
        }

        if (payload.innerWidth < 1680 || payload.innerHeight < 1050) {
            isSmallDesktop = true;
        }

        if (payload.innerWidth < 500 || payload.innerHeight < 700) {
            isMobile = true;
        }

        if (isMobile && payload.innerHeight < payload.innerWidth) {
            isPortrait = false;
        }

        if (isDesktop) {
            document.querySelector('body').style.fontSize = '14px';
            document.querySelector('html').style.fontSize = '14px';
        } else {
            document.querySelector('body').style.fontSize = '12px';
            document.querySelector('html').style.fontSize = '12px';
        }
         
        state.isDesktop = isDesktop;
        state.isMobile = isMobile;
        state.isSmallDesktop = isSmallDesktop;
        state.isPortrait = isPortrait;

    }, // eof mut_set_isDesktop()

    

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Shared' - 'Login'
    ***************************************************************************/
    /*************************************************************************** Step 1
    * actn_userLogin()
    *
    * Desc: (Call) - User Login.
    * Note: Set Headers Authorization here!
    * Note: Load Countries & More from here.
    * Note: NEW! We now have 'grants' in Logins Response.
    *
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_userLogin: (context, payload) => {

        let hdrs = '',
            url = 'acm/acl/login';


        // >>> Set 'Authorization' Header -------
        axios.defaults.headers.Authorization = Vue.prototype.$make_basic_auth(payload);

        Vue.prototype.$vp_m();
        axios.get(url, payload.params)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_userLogin', response.data);             // calling mutation


                        context.dispatch("actn_call_getCountries", {});         // load countries
                        context.dispatch("actn_call_getAirportTaxes", {});         // load airportTaxes
                        // context.dispatch("actn_call_getHotelGoodies", {});      // load hotel gooddies
                        context.dispatch("actn_call_getAircraftConfigs", {});      // load aircrafts
                        context.dispatch("actn_call_getBlocktimes", {});        // load block times
                        context.dispatch("actn_call_getAirports", {});


                        // context.dispatch("actn_call_getAirport", {});        // load airports
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_userLogin()


    /***************************************************************************
    * actn_userLogout()
    *
    * Desc:
    * Note:
    *
    */
    actn_userLogout: (context, payload) => {

        console.log('TODO: actn_userLogout');

    }, // eof actn_userLogout()


    /***************************************************************************
    * actn_userSignup()
    *
    * Desc:
    * Note:
    *
    */
    actn_userSignup: (context, payload) => {

        console.log('TODO: actn_userSignup');

    }, // eof actn_userSignup()




    /***************************************************************************
    * Actions: 'Shared' - 'Path'
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Path()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_Path: (context, payload) => {

        context.commit('mut_set_Path', payload.data);

    }, // eof actn_set_Path()




    /***************************************************************************
    * Actions: 'Shared' - 'Drawer'
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Drawer()
    *
    * Desc:
    * Note:
    *
    */
    actn_set_Drawer: (context, payload) => {

        context.commit('SET_DRAWER', payload);

    }, // eof actn_set_Drawer()




    /***************************************************************************
    * Actions: 'Shared' - Load Countries
    ***************************************************************************/
    /***************************************************************************
    * Call::'/info/countries'
    *
    * Desc: Call: Get List of Countries.
    * Note:
    *
    */
    actn_call_getCountries: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/info/countries')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Countries', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getCountries()




    /***************************************************************************
    * Actions: 'Shared' - - Load Bases
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/bases'
    *
    * Desc: Call: Get List of Bases.
    * Note:
    *
    */
    actn_call_getBases: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/humanresources/bases')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_Bases', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBases()




    /***************************************************************************
    * Actions: 'Shared' - Load Aircraft(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'acm/forms/aircraftconfigs'
    *
    * Desc: Call: Get List of Aircrafts.
    * Note:
    *
    */
    actn_call_getAircraftConfigs: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/forms/aircraftconfigs')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AircraftConfigs', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()


    /***************************************************************************
    * Actions: 'Shared' - Load Airport Taxes
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/airport/taxes'
    *
    * Desc: Call: Get List of Airport Taxes.
    * Note:
    *
    */
    actn_call_getAirportTaxes: (context) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.get('/acm/airport/taxes')
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_AirportTaxes', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getAircraftConfigs()



    /***************************************************************************
    * Actions: 'Shared' - 'All Employees'
    ***************************************************************************/
    /***************************************************************************
    * actn_call_load_AllEmployees()
    *
    * Desc: (Call) - Load 'All Employees'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note:
    *
    */
    actn_call_load_AllEmployees: (context, payload) => {

        let hdrs = '';


        axios.get('/humanresources/resource/active', payload.params)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_AllEmployees', response.data); // calling mutation
                        eventBus.$emit('onallemployeesloaded', {});             //
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                        break;
                }
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_call_load_AllEmployees()




    /***************************************************************************
    * Actions: 'Shared' - 'All Employees - Save Duty Plan Changes'
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/dutyplan/generate'
    *
    * Desc: (Call) - Update multiple Ressources. Save Duty Plan Changes.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_DutyPlanChanges: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/dutyplan/generate', payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_update_DutyPlanChanges', response.data); // calling mutation

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Save Duty Plan Changes - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                }
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eof actn_update_DutyPlanChanges()




    /***************************************************************************
    * Actions: 'Shared' - All Employees - Selected Resources'
    ***************************************************************************/
    /***************************************************************************
    * actn_set_shared_SelectedMultiResources()
    *
    * Desc: Set
    * Note:
    *
    */
    actn_set_shared_SelectedMultiResources: (context, payload) => {

        context.commit('mut_set_shared_SelectedMultiResources', payload);

    }, // eof actn_set_shared_SelectedMultiResources()

    /***************************************************************************
    * Actions: 'Shared' - Set Warning (Dialog Popover)
    ***************************************************************************/
    /***************************************************************************
    * actn_set_warning()
    *
    * Desc: Set
    * Note:
    *
    */
    actn_set_warning: (context, payload) => {

        context.commit('mut_set_warning', payload);

    }, // eof actn_set_warning()

    /***************************************************************************
    * Actions: 'Shared' - Set smallScreen
    ***************************************************************************/
    /***************************************************************************
    * actn_set_isDesktop()
    *
    * Desc: Set
    * Note:
    *
    */
    actn_set_isDesktop: (context, payload) => {

        context.commit('mut_set_isDesktop', payload);

    }, // eof actn_set_isDesktop()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};
